import styled from 'styled-components';

type SideCardRelativeWrapProps = {
    cartIsVisible: boolean;
};

export const SideCardRelativeWrap = styled.div<SideCardRelativeWrapProps>`
    padding: 0 0.5rem;
    flex: ${({ cartIsVisible }) => (cartIsVisible ? 1 : 0)};
    /* transition: all 0.3s ease-in-out; */
    position: relative;
    transform: ${({ cartIsVisible }) =>
        cartIsVisible ? 'translateX(0)' : 'translateX(100%)'};
    opacity: ${({ cartIsVisible }) => (cartIsVisible ? 1 : 0)};
    overflow: hidden;
    height: 100%;
`;

export const SideCardShopWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    width: 100%;
    height: 100%;

    padding: 0.25rem;
`;

export const EmpyValuesCard = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;

    color: ${({ theme }) => theme.colors['silver-700']};

    p {
        color: ${({ theme }) => theme.colors['silver-500']};
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1rem; /* 114.286% */
    }
`;

export const ElementCartWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 0.75rem 0.5rem;

    border-bottom: 2px solid ${({ theme }) => theme.colors['neutral-800']};
`;

export const ElementsTextInfosWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: self-start;

    gap: 0.2rem;

    span {
        color: ${({ theme }) => theme.colors['neutral-800']};
        font-size: 1rem;
        font-weight: 500;
    }
`;

export const HoursElementsText = styled.h3`
    color: ${({ theme }) => theme.colors['neutral-500']};

    font-size: 0.75rem;
    font-weight: 500;
`;

export const ValuesCartWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    gap: 1rem;

    h2 {
        font-weight: 700;
        font-size: 1rem;
    }
`;

export const ElementTotalSum = styled.div`
    width: 100%;

    padding: 0.5rem;
    justify-content: space-between;
    align-items: center;
    border-top: 2px solid ${({ theme }) => theme.colors['neutral-800']};
    border-bottom: 2px solid ${({ theme }) => theme.colors['neutral-800']};

    span {
        font-size: 1rem;
        color: ${({ theme }) => theme.colors['silver-500']};
    }

    h2 {
        font-size: 1rem;
    }
`;

export const ElementValuesSum = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
        font-size: 1rem;
        color: ${({ theme }) => theme.colors['silver-500']};
    }

    h2 {
        font-size: 1rem;
    }
`;

export const ShopElementsWrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0.75rem;
    overflow: auto;

    &[aria-selected='true'] {
        height: 100%;
    }
`;

export const ElementsWrap = styled.div`
    height: 100%;
    width: 100%;


    > .divider {
        height: 1px;
        max-height: 1px;
        width: 100%;
        background-color: #27272A;
        opacity: .5;
    }

    .divider:last-of-type {
        background-color: transparent;
    }
`;

export const ActionsButtonsFooterWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    width: 100%;
`;

export const DiscountValue = styled.h2`
    color: #28a745;
`